import { render, staticRenderFns } from "./ModalTermsOfUse.vue?vue&type=template&id=56485dce&"
import script from "./ModalTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./ModalTermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermsOfUse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VDialog,VRow})
